const ITEMS = [
  "Parent",
  "Resident",
  "Technology Leader",
  "Community Advocate",
  "Student Success",
  "Fresh Perspective",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section className="border-y border-slate-200 bg-slate-900 py-6 overflow-hidden" data-testid="marquee">
      <div className="flex w-max animate-marquee">
        {row.map((item, i) => (
          <div key={i} className="flex items-center whitespace-nowrap">
            <span className="font-display text-3xl md:text-4xl font-bold tracking-tight text-white px-8">
              {item}
            </span>
            <span className="h-2 w-2 rounded-full bg-teal-400" />
          </div>
        ))}
      </div>
    </section>
  );
};
